export default function MultiSelectChip({
  label,
  required = false,
  placeholder = "Select an option",
  options = [],
  selected = [],
  onChange,
  name,
  className = "",
}) {
  const availableOptions = options.filter((opt) => !selected.includes(opt.value));
 
  const handleSelect = (e) => {
    const val = e.target.value;
    if (!val) return;
    onChange?.([...selected, val]);
    e.target.value = "";
  };
 
  const handleRemove = (val) => {
    onChange?.(selected.filter((v) => v !== val));
  };
 
  // Get label for a value
  const getLabel = (val) => options.find((o) => o.value === val)?.label ?? val;
 
  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      {/* Label */}
      {label && (
        <label className="text-sm font-medium text-gray-700">
          {label}
          {required && <span className="text-red-500 ml-0.5">*</span>}
        </label>
      )}
 
      {/* Select */}
      <select
        name={name}
        onChange={handleSelect}
        defaultValue=""
        className="border border-gray-300 rounded-md py-2.5 px-[14px] text-[#667085] text-[14px] focus:outline-none focus:ring-1 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all duration-200 appearance-none cursor-pointer hover:border-gray-400 bg-white w-full"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23333' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right 12px center",
          backgroundSize: "12px",
        }}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {availableOptions.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
 
      {/* Chips */}
      {selected.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-1">
          {selected.map((val) => (
            <span
              key={val}
              className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full border border-gray-300 bg-white text-sm text-gray-700"
            >
              {getLabel(val)}
              <button
                type="button"
                onClick={() => handleRemove(val)}
                className="text-red-500 hover:text-red-700 transition-colors leading-none focus:outline-none"
                aria-label={`Remove ${getLabel(val)}`}
              >
                ✕
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
 